"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOrderPreviewItemHash = calculateOrderPreviewItemHash;
exports.prepareOrderItemsBody = prepareOrderItemsBody;
var _lodash = require("lodash");
var _md = _interopRequireDefault(require("md5"));
var _orderItemStatusEnum = _interopRequireDefault(require("../enums/orderItemStatusEnum"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function mergeOrderItemsForPreview(_ref) {
  var order = _ref.order,
    currentOrderItem = _ref.currentOrderItem;
  var orderItemsIds = _toConsumableArray(order.orderItemsIds);
  var orderItems = _objectSpread({}, order.orderItems);
  if (currentOrderItem && currentOrderItem.orderItemStatus > _orderItemStatusEnum["default"].INITIAL) {
    orderItems[currentOrderItem.apiId] = currentOrderItem;
    orderItemsIds.push(currentOrderItem.apiId);
  }
  orderItemsIds = (0, _lodash.uniq)(orderItemsIds);
  return {
    orderItemsIds: orderItemsIds,
    orderItems: orderItems
  };
}
function prepareOrderItemBody(_ref2) {
  var orderItem = _ref2.orderItem,
    preview = _ref2.preview;
  var ingredientsServingsStoreKey = preview ? "highlightedIngredientServings" : "selectedIngredientServings";
  return orderItem.personalSettings.map(function (personalSetting) {
    return {
      menu_item: orderItem.apiId,
      personal_settings: personalSetting,
      landing_page_slug: orderItem.landingPageSlug,
      ingredient_servings: (0, _lodash.mapValues)(orderItem[ingredientsServingsStoreKey], function (servings) {
        return servings.toString();
      }),
      is_upsold: orderItem.isUpsold || false
    };
  });
}

/* Serializes order items data for submission to the order api */
function prepareOrderItemsBody(_ref3) {
  var order = _ref3.order,
    currentOrderItem = _ref3.currentOrderItem,
    preview = _ref3.preview;
  var _mergeOrderItemsForPr = mergeOrderItemsForPreview({
      order: order,
      currentOrderItem: currentOrderItem
    }),
    orderItemsIds = _mergeOrderItemsForPr.orderItemsIds,
    orderItems = _mergeOrderItemsForPr.orderItems;
  return orderItemsIds.map(function (orderItemId) {
    return orderItems[orderItemId];
  }).map(function (orderItem) {
    return prepareOrderItemBody({
      orderItem: orderItem,
      preview: preview
    });
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []);
}
function menuItemIngredientServingsHash(_ref4) {
  var menuItemId = _ref4.menuItemId,
    ingredientServingsPairs = _ref4.ingredientServingsPairs;
  var stringifiedIngredientServings = (0, _lodash.flatten)((0, _lodash.sortBy)(ingredientServingsPairs, function (pair) {
    return parseFloat(pair[0]);
  }));
  return (0, _md["default"])("".concat(menuItemId).concat(stringifiedIngredientServings));
}
function calculateOrderPreviewItemHash(orderPreviewItem) {
  var ingredientServingsPairs = orderPreviewItem.menu.ingredients.map(function (ingredient) {
    return [ingredient.ingredient, parseFloat(ingredient.serving)];
  });
  return menuItemIngredientServingsHash({
    menuItemId: orderPreviewItem.menu.id,
    ingredientServingsPairs: ingredientServingsPairs
  });
}